import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Result } from 'app/core/models/result';
import { QuestionBankQuestionListModel } from 'app/question/models/question-bank-question-list.model';
import { QuestionBankQuestionReorderModel } from 'app/question/models/question-bank-question-reorder.model';
import { QuestionService } from 'app/question/services/question.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
    selector: 'app-question-bank-question-list',
    templateUrl: './question-bank-question-list.component.html',
    styleUrls: ['./question-bank-question-list.component.css']
})
export class QuestionBankQuestionListComponent implements OnInit {
    @Input() questionBankId: string;
    @Input() isEditMode: boolean = false;
    @Output() questionBankQuestionsUpdated: EventEmitter<string> = new EventEmitter<string>();
    selectedQuestionBankQuestionId: string;
    errors: string[];
    questionBankQuestions: QuestionBankQuestionListModel[];

    constructor(
        private questionService: QuestionService
    ) { }

    ngOnInit() {
        this.load();
    }

    load(): void {
        this.questionService.getQuestionBankQuestions(this.questionBankId).subscribe(
            questionBankQuestions => {
                this.questionBankQuestions = questionBankQuestions;
            },
            error => this.errors = error.errorList
        );
    }

    onQuestionBankQuestionAdded($event): void {
        this.questionBankQuestionsUpdated.emit("Updated");        
        this.load();
    }

    deleteQuestionBankQuestion(): void {
        this.questionService.deleteQuestionBankQuestion(this.selectedQuestionBankQuestionId).subscribe(
            result => {
                this.questionBankQuestionsUpdated.emit("Updated");
                this.load();
            },
            error => this.errors = (<Result>error).errorList
        );
    }

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.questionBankQuestions, event.previousIndex, event.currentIndex);

        let model = new QuestionBankQuestionReorderModel();
        var i;
        for (i = 0; i < this.questionBankQuestions.length; i++) {
            model.id = this.questionBankQuestions[i].id;
            model.zOrder = i + 1;
            this.questionService.reorderQuestionBankQuestion(model).subscribe(                
                () => {},
                error => this.errors = (<Result>error).errorList
            );
        }
    }

    toggleMandatory(questionBankQuestion: QuestionBankQuestionListModel): void {
        this.questionService.toggleMandatoryQuestionBankQuestion(questionBankQuestion).subscribe(
            () => {
                this.load();
            },
            error => this.errors = (<Result>error).errorList
        );
    }

}
